import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'
import axios from 'axios'
import { isAdmin } from '../../../utilities/isAdmin'
import { format } from 'date-fns'
import { Container, Button, Message, Form, FormField, Icon, Input, Divider, Header, Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell, Popup, Pagination } from 'semantic-ui-react'

const Account = () => {
    const [itemsPerPage] = useState(20)
    const [activePage, setActivePage] = useState(0)
    const [fxRateMarkUp, setFxRateMarkUp] = useState('')
    const [password, setPassword] = useState('')
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)
    const [yahooRate, setYahooRate] = useState(0)
    const [innerWidth] = useState(window.innerWidth)

    const user = useSelector(state => state.userReseller)
    const settings = useSelector(state => state.settings)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.fetchSettings())
        axios.get('/api/yahoo_finance_rate')
            .then(res => setYahooRate(res.data.rate))
            .catch(err => alert('Fail to get Yahoo Finance rate, please try again. Error: ' + err))
    }, [dispatch])

    useEffect(() => {
        if (settings) {
            console.log(settings)
            setFxRateMarkUp(settings.fxRateMarkUp || '')
        }
    }, [settings])

    const renderPagination = () => {
        if (!user.balanceHistory) return null
        const pagesRequired = Math.ceil(user.balanceHistory.length / itemsPerPage)
        return <Pagination inverted defaultActivePage={1} totalPages={pagesRequired} siblingRange={2} onPageChange={handlePageChange}/>
    }

    const renderTableRows = () => {
        if (!user.balanceHistory) return null
        const rows = []
        for (const [i, transaction] of user.balanceHistory.entries()) {
            rows.push(
                <TableRow key={i}>
                    {!!transaction.date ? (
                        <TableCell style={{ color: 'white' }}>
                            {format(new Date(transaction.date), 'd MMM yyyy, h:mm a')}
                        </TableCell>) : (<TableCell></TableCell>)}
                    <TableCell style={{ color: 'white' }}>{transaction.old.toFixed(2)}</TableCell>
                    <TableCell style={{ color: 'white' }}>{transaction.new.toFixed(2)}</TableCell>
                    <TableCell style={{ color: 'white' }}>
                        {stringifyTransactionType(transaction.type)}
                        {transaction.type === 'order_placed' && !!transaction.order ? (
                            <Popup inverted wide trigger={<Icon inverted circular name="info" size="small" />} position="bottom left">
                                <span style={{ color: 'white' }}>
                                    Order ID: {transaction.order.id}<br />
                                    Date: {format(new Date(transaction.order.date), 'd MMM yyyy, h:mm a')}<br />
                                    Item: {transaction.order.item}<br />
                                    Amount: ${transaction.order.amount}
                                </span>
                            </Popup>
                        ) : null}
                    </TableCell>
                </TableRow>
            )
        }
        return rows.reverse().slice(activePage * itemsPerPage, activePage * itemsPerPage + itemsPerPage)
    }

    const handlePageChange = (e, { activePage }) => {
        const page = activePage - 1
        setActivePage(page)
    }

    const handleChangePassword = e => {
        setPassword(e.target.value)
        setShowSuccessMessage(false)
    }

    const handleLogout = () => {
        window.localStorage.setItem('verified2FA', null)
        dispatch(actions.logout(isAdmin(user)))
    }

    const saveToServer = () => {
        const dict = { id: user._id, password }
        axios.post('/api/reseller/change_password', dict)
            .then(() => {
                setShowSuccessMessage(true)
            })
            .catch(err => {
                console.log('save settings failed with error: ' + err)
                alert('Fail to save settings, please try again. Error: ' + err)
            })
    }

    const str = yahooRate === 0 ? 'Loading exchange rate...' : 'Please note that our current exchange rate is 1 USD to ' + (yahooRate - fxRateMarkUp / 100).toFixed(4) + ' SGD.'
    const style = innerWidth > 1035 ? { marginTop: 20 } : { marginTop: 20, overflowX: 'auto', display: 'block', whiteSpace: 'nowrap' }
    return <Container inverted style={{ background: '#1b1c1d' }}>
            <h1 style={{ marginTop: 30, marginBottom: 30, color: 'white' }}>My Account</h1>
            {showSuccessMessage ? (
                <Message inverted success header="Successfully changed password" />
            ) : null}
            <Form inverted>
                <Message inverted style={{ marginBottom: 30, backgroundColor: '#1b1c1d', color: 'white', border: '1px solid #555' }} icon="dollar" header="Exchange Rate" content={str}/>
                <FormField control={Input} label="Change Account Password" value={password} placeholder="New password" type="password" onChange={handleChangePassword} inverted input={<input style={{ backgroundColor: '#1b1c1d', color: 'white' }}/>}/>
                <Button inverted style={{ marginTop: 15 }} color='teal' size="small" onClick={saveToServer}><Icon inverted color='teal' name="save" />Save</Button>
            </Form>
            <Button inverted style={{ marginTop: 15 }} size="small" color="red" onClick={handleLogout}>Sign out</Button>
            <Divider inverted style={{ marginTop: 25, marginBottom: 20 }} horizontal>
                <Header inverted as="h4"><Icon inverted name="history" />Account Balance History</Header>
            </Divider>
            <Table inverted style={style} size={innerWidth < 768 ? 'small' : ''} celled striped unstackable>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Date</TableHeaderCell>
                        <TableHeaderCell>Old Balance</TableHeaderCell>
                        <TableHeaderCell>New Balance</TableHeaderCell>
                        <TableHeaderCell>Type</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {renderTableRows()}
                </TableBody>
            </Table>
            {renderPagination()}
        </Container>
}

const stringifyTransactionType = type => {
    if (type === 'initial') return 'Starting Account Balance'
    if (type === 'order_placed') return 'Order placed'
    if (type === 'order_refunded') return 'Order refunded'
    if (type === 'top_up') return 'Account Top up'
    if (type === 'deduct') return 'Account Deduction'
    return type
}

export default Account